import React, { useMemo, useState } from "react";
import Table from "common/graphs/Table/Table";
import { atoiv6, atoiv4 } from "common/utils";
import styled from "styled-components";

const TableContainer = styled.div`
  width: 100%;
  .toolbar {
    display: block !important;
    width: 100%;
    .toolbar-right {
      justify-content: flex-end;
      align-items: center;
    }
    .toolbar-left {
      justify-content: flex-start;
      align-items: center;
    }
  }
`;

const doesNothing = () => {};

const getColumns = (onDelete) => {
  return [
    {
      label: "ADDRESS",
      id: "address",
      numeric: false,
      parse: (value) => {
        if (!value) {
          return 0;
        }
        return value.includes(":") ? atoiv6(value) : atoiv4(value);
      },
      parseFilter: (value) => value
    },
    {
      label: "ACTIONS",
      id: "ACTIONS",
      actions: [
        {
          label: "Delete",
          icon: "delete",
          onClick: (row) => onDelete([row["__id"]]),
        },
      ],
    },
  ];
};

const ClientsList = ({ items = [], onDelete = doesNothing }) => {
  const [selected, setSelected] = useState([]);
  const columns = useMemo(() => getColumns(onDelete), [onDelete]);

  const filteredItems = items.filter(({ deleted }) => deleted !== true).map((item, index) => ({
    ...item,
    id: item.__id !== undefined ? item.__id : index
  }));

  return (
    <TableContainer>
      <Table
        columns={columns}
        data={filteredItems}
        exportCSV={false}
        isSelectable={true}
        isRowSelectable={false}
        selected={selected}
        setSelected={setSelected}
        deleteSelected={(values) => {
          onDelete(values);
          setSelected([]);
        }}
      />
    </TableContainer>
  );
};

export default ClientsList;
